import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PointsSymbol from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { getVideoCreatorRestrictions } from '../../../../../selectors/studio';

import s from './VideoPointsBalance.scss';

interface Props {}

const VideoPointsBalance: FC<Props> = () => {
  const { t } = useTranslation();
  const { pointsBalance } = useSelector(getVideoCreatorRestrictions);
  const formattedPointsBalance =
    Intl.NumberFormat('en-US').format(pointsBalance);
  return (
    <div className={s['root']}>
      <span className={s['points-label']}>
        {t('studio.videoCreator.pointsBalance.label')}
      </span>
      <span className={s['points-bold']}>
        <PointsSymbol className={s['points-icon']} size={IconSize.SMALL} />
        {`${formattedPointsBalance} ${t('studio.videoCreator.pointsLabel')}`}
      </span>
    </div>
  );
};

VideoPointsBalance.displayName = 'VideoPointsBalance';

export default VideoPointsBalance;
